import type {
  ActivityType, CallOutcome, ContactRole, LeadSource, LifecycleStage, NotificationType, Priority, StageKind,
  SubmissionStatus, TaskKind, TaskStatus, UserRole,
} from './enums';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'מנהל מערכת',
  manager: 'מנהל מכירות',
  sales: 'איש מכירות',
  viewer: 'צפייה בלבד',
};

export const LIFECYCLE_LABELS: Record<LifecycleStage, string> = {
  lead: 'ליד',
  customer: 'לקוח',
  archived: 'בארכיון',
};

export const SOURCE_LABELS: Record<LeadSource, string> = {
  website: 'אתר',
  meta: 'Meta',
  google: 'Google',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  whatsapp: 'WhatsApp',
  phone: 'טלפון',
  referral: 'המלצה',
  exhibition: 'תערוכה',
  manual: 'הוזן ידנית',
  other: 'אחר',
};

export const PRIORITY_LABELS: Record<Priority, string> = {
  low: 'נמוכה',
  normal: 'רגילה',
  high: 'גבוהה',
  urgent: 'דחוף',
};

export const CONTACT_ROLE_LABELS: Record<ContactRole, string> = {
  owner: 'בעלים',
  purchasing: 'רכש',
  finance: 'כספים',
  operations: 'תפעול',
  branch_manager: 'מנהל סניף',
  chef: 'שף / קונדיטור',
  barista: 'בריסטה',
  other: 'אחר',
};

export const ACTIVITY_LABELS: Record<ActivityType, string> = {
  lead_created: 'ליד נוצר',
  website_enquiry: 'פנייה מהאתר',
  meta_lead: 'ליד מ-Meta',
  tiktok_lead: 'ליד מ-TikTok',
  call: 'שיחה',
  whatsapp: 'WhatsApp',
  email: 'אימייל',
  note: 'הערה',
  task: 'משימה',
  meeting: 'פגישה',
  sample: 'דוגמית',
  quote: 'הצעת מחיר',
  order: 'הזמנה',
  invoice: 'חשבונית',
  payment: 'תשלום',
  stage_change: 'שינוי שלב',
  system: 'מערכת',
};

export const CALL_OUTCOME_LABELS: Record<CallOutcome, string> = {
  answered: 'נענתה',
  no_answer: 'לא ענה',
  busy: 'תפוס',
  left_message: 'הושארה הודעה',
  wrong_number: 'מספר שגוי',
};

export const TASK_KIND_LABELS: Record<TaskKind, string> = {
  followup: 'פולואפ',
  task: 'משימה',
  meeting: 'פגישה',
  call: 'שיחה מתוכננת',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  open: 'פתוחה',
  done: 'בוצעה',
  cancelled: 'בוטלה',
};

export const STAGE_KIND_LABELS: Record<StageKind, string> = {
  open: 'פתוח',
  won: 'נסגר בהצלחה',
  lost: 'נסגר ללא הצלחה',
};

export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  received: 'התקבל',
  created: 'נוצר ליד חדש',
  attached: 'צורף לקיים',
  pending_review: 'חשד לכפילות',
  rejected: 'נדחה',
  error: 'שגיאה',
};

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  new_lead: 'ליד חדש',
  website_lead: 'ליד מהאתר',
  duplicate_suspected: 'חשד לכפילות',
  enquiry_attached: 'פנייה חוזרת',
  followup_today: 'פולואפ להיום',
  followup_overdue: 'פולואפ באיחור',
  meeting: 'פגישה',
  quote_followup: 'מעקב הצעת מחיר',
  reorder_due: 'הזמנה חוזרת צפויה',
  invoice_overdue: 'חשבונית באיחור',
  low_stock: 'מלאי נמוך',
  assigned: 'שויך אליך',
  system: 'מערכת',
};

/** Business types offered by the website form (kept identical to takumimatcha.co.il/contact). */
export const BUSINESS_TYPES = [
  'בית קפה', 'רשת קפה', 'עגלת קפה', 'מסעדה', 'קונדיטוריה / מאפייה', 'גלידריה', 'חנות טבע', 'מעדנייה / חנות מתמחה',
  'מלון / אירוח', 'קייטרינג / אירועים', 'רשת מזון / קמעונאות', 'חדר כושר / סטודיו', 'בר משקאות', 'אחר',
] as const;
